"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const ecommerce_1 = require("../../api/ecommerce");
const array_1 = require("../../common/js/helper/array");
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
const PropertyGroups_1 = __importDefault(require("../enums/PropertyGroups"));
const product_1 = require("../helper/product");
const CATEGORY_ASSOCIATIONS = {
    massiveMaterials: {
        associations: {
            massiveMaterialGroup: { ' ': 1 },
        },
    },
    massiveTools: {
        ' ': 1,
    },
    visibilities: { ' ': 1 },
    properties: {
        associations: {
            group: {
                associations: {
                    massivePropertyGroup: { ' ': 1 },
                },
            },
            translations: { ' ': 1 },
        },
    },
};
const PRODUCT_ASSOCIATIONS = {
    categories: { ' ': 1 },
    properties: {
        associations: {
            group: {
                associations: {
                    massivePropertyGroup: { ' ': 1 },
                },
            },
            translations: { ' ': 1 },
        },
    },
    media: { ' ': 1 },
    massiveMaterials: {
        associations: {
            massiveMaterialGroup: { ' ': 1 },
        },
    },
    massiveTools: {
        ' ': 1,
    },
    massiveApplications: {
        associations: {
            media: { ' ': 1 },
        },
    },
};
class ShopwareProducts {
    api = new ecommerce_1.ProductApi(configuration_1.default);
    cachedProducts = new Map();
    internalConfiguratorList = [];
    loadingCounter = 0;
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            cachedProducts: mobx_1.observable,
            internalConfiguratorList: mobx_1.observable,
            loadingCounter: mobx_1.observable,
            configuratorList: mobx_1.computed,
            isLoading: mobx_1.computed,
            subscriptionOptionsConfigurator: mobx_1.computed,
            subscriptionOptions: mobx_1.computed,
        });
    }
    get configuratorList() {
        return this.internalConfiguratorList;
    }
    get isLoading() {
        return this.loadingCounter > 0;
    }
    get subscriptionOptionsConfigurator() {
        if (this.configuratorList.length < 1) {
            return null;
        }
        return (0, array_1.first)(this.configuratorList.filter((item) => item.id === PropertyGroups_1.default.SUBSCRIPTION_OPTIONS)) ?? null;
    }
    get subscriptionOptions() {
        const options = this.subscriptionOptionsConfigurator?.options ?? [];
        return options.slice().sort((a, b) => (a.translated?.position ?? 0) - (b.translated?.position ?? 0));
    }
    loadProductsForCategory(categoryId, includeNotPurchasable = false) {
        this.loadingCounter++;
        return this.api
            .readProductsInCategory({
            categoryId: categoryId,
            includeNotPurchasable,
            requestBody: {
                associations: CATEGORY_ASSOCIATIONS,
                includes: __APP__.PRODUCT_REQUEST_BODY_INCLUDES,
                limit: 500,
                page: 1,
            },
        })
            .then((productResponse) => {
            return productResponse.elements ?? [];
        })
            .finally(() => this.loadingCounter--);
    }
    getProduct(id) {
        return this.cachedProducts.get(id);
    }
    getProductByProductNumber(productNumber) {
        return (0, array_1.first)(Array.from(this.cachedProducts.values()).filter((product) => product.productNumber === productNumber));
    }
    loadVariants(baseProduct) {
        this.loadingCounter++;
        return this.api
            .readProductList({
            requestBody: {
                associations: PRODUCT_ASSOCIATIONS,
                filter: [
                    {
                        field: 'parentId',
                        value: baseProduct.parentId,
                        type: 'equals',
                    },
                ],
                includes: __APP__.PRODUCT_REQUEST_BODY_INCLUDES,
            },
        })
            .then((productResponse) => {
            const massiveComputedSoftwareLicense = baseProduct.extensions?.massiveComputedSoftwareLicense;
            if (!!massiveComputedSoftwareLicense) {
                productResponse.elements?.forEach((product) => {
                    product.extensions = {
                        ...(product.extensions ?? {}),
                        massiveComputedSoftwareLicense,
                    };
                });
            }
            return productResponse.elements ?? [];
        })
            .finally(() => this.loadingCounter--);
    }
    loadProductCrossSellingProductsMappings(productId) {
        this.loadingCounter++;
        return this.api.readCrossSellingProductsMappings({ productId }).finally(() => this.loadingCounter--);
    }
    loadProduct(productId, useConfigurator = false, includeNotPurchasable = false) {
        this.loadingCounter++;
        return this.api
            .readProduct({
            productId,
            includeNotPurchasable: includeNotPurchasable ? true : false,
            requestBody: {
                associations: PRODUCT_ASSOCIATIONS,
                includes: __APP__.PRODUCT_REQUEST_BODY_INCLUDES,
            },
        })
            .then((productResponse) => {
            this.cachedProducts.set(productId, productResponse.product);
            if (useConfigurator) {
                this.internalConfiguratorList = productResponse.configurator ?? [];
            }
            return productResponse.product;
        })
            .finally(() => this.loadingCounter--);
    }
    loadProductWithProductNumber(productNumber) {
        this.loadingCounter++;
        return this.api
            .readProductList({
            requestBody: {
                associations: PRODUCT_ASSOCIATIONS,
                filter: [
                    {
                        field: 'productNumber',
                        value: productNumber,
                        type: 'equals',
                    },
                ],
                includes: __APP__.PRODUCT_REQUEST_BODY_INCLUDES,
                limit: 1,
            },
        })
            .then((productResponse) => {
            const product = productResponse.elements?.[0];
            if (undefined === product) {
                throw new Error(`Couldn't read product with product number "${productNumber}".`);
            }
            this.cachedProducts.set(product.id, product);
            if ((0, product_1.isProductCategorySoftware)(product)) {
                return this.loadProduct(product.id, true);
            }
            return product;
        })
            .finally(() => this.loadingCounter--);
    }
    loadProducts(productIds, softLoad = false) {
        if (softLoad) {
            productIds = productIds.filter((productId) => !this.cachedProducts.get(productId));
        }
        if (productIds.length <= 0) {
            return Promise.resolve([]);
        }
        this.loadingCounter++;
        return this.api
            .readProductList({
            requestBody: {
                associations: PRODUCT_ASSOCIATIONS,
                ids: productIds,
                includes: __APP__.PRODUCT_REQUEST_BODY_INCLUDES,
            },
        })
            .then((productResponse) => {
            productResponse.elements?.map((product) => {
                this.cachedProducts.set(product.id, product);
            });
            return productResponse.elements ?? [];
        })
            .finally(() => this.loadingCounter--);
    }
    loadProductsWithProductNumbers(productNumbers, softLoad = false) {
        if (softLoad) {
            productNumbers = productNumbers.filter((productNumber) => Array.from(this.cachedProducts.values()).filter((product) => product.productNumber === productNumber).length === 0);
        }
        if (productNumbers.length <= 0) {
            return Promise.resolve([]);
        }
        this.loadingCounter++;
        return this.api
            .readProductList({
            requestBody: {
                associations: PRODUCT_ASSOCIATIONS,
                includes: __APP__.PRODUCT_REQUEST_BODY_INCLUDES,
                filter: [
                    {
                        field: 'productNumber',
                        value: productNumbers,
                        type: 'equalsAny',
                    },
                ],
            },
        })
            .then((productResponse) => {
            productResponse.elements?.map((product) => {
                this.cachedProducts.set(product.id, product);
            });
            return productResponse.elements ?? [];
        })
            .finally(() => this.loadingCounter--);
    }
}
__decorate([
    bind_decorator_1.default
], ShopwareProducts.prototype, "loadProductsForCategory", null);
__decorate([
    bind_decorator_1.default
], ShopwareProducts.prototype, "getProduct", null);
__decorate([
    bind_decorator_1.default
], ShopwareProducts.prototype, "getProductByProductNumber", null);
__decorate([
    bind_decorator_1.default
], ShopwareProducts.prototype, "loadVariants", null);
__decorate([
    bind_decorator_1.default
], ShopwareProducts.prototype, "loadProductCrossSellingProductsMappings", null);
__decorate([
    bind_decorator_1.default
], ShopwareProducts.prototype, "loadProduct", null);
__decorate([
    bind_decorator_1.default
], ShopwareProducts.prototype, "loadProductWithProductNumber", null);
__decorate([
    bind_decorator_1.default
], ShopwareProducts.prototype, "loadProducts", null);
__decorate([
    bind_decorator_1.default
], ShopwareProducts.prototype, "loadProductsWithProductNumbers", null);
exports.default = new ShopwareProducts();
